/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button } from '../../components';
import { insereDados } from '../../store/actions/questionario-actions';
import { api } from '../../services';

function Main(props) {
  const [valid, setValid] = useState({});
  const schema = Yup.object().shape({
    vantagens: Yup.string()
      .min(2, 'Esse campo  é essencial')
      .required('Esse campo é essencial'),
  });
  const onChange = (event) => {
    const { name, value } = event.target;
    props.insereDados(name, value);
  };
  const handleSendEmail = async () => {
    const { dados } = props;
    if (props.dados.uf !== '') {
      dados.localizacao = `${props.dados.localizacao}/${props.dados.uf}`;
    }
    delete dados.uf;
    const formData = new FormData();
    for (const key in dados) {
      formData.append(key, dados[key]);
    }
    try {
      await api.post('', formData);
      props.history.push('/enviada');
    } catch (e) {
      console.log(e);
    }
  };
  const confirmar = (e) => {
    e.preventDefault();
    const dados = {
      vantagens: props.dados.vantagens,
    };
    schema.validate(dados).then(
      () => {
        handleSendEmail();
      },
    ).catch((err) => {
      setValid(err);
    });
  };
  const [isVerificado, setVerificado] = useState(false);
  return (
    <form onSubmit={confirmar}>
      <h3>{
        (props.dados.tipocrimepraticado !== 'Corrupção.' && props.dados.atodecorrupcao === '')
        || (props.dados.tipocrimesofrido !== 'Corrupção.' && props.dados.atodecorrupcao === '') ? '6'
          : props.dados.atodecorrupcao === 'licitações ou contratos' ? '7' : '8'} - Escreva de forma detalhada o fato ocorrido:
      </h3>
      <textarea
        name="descricao"
        cols="100"
        rows="10"
        onChange={onChange}
      /><br />


      <ReCAPTCHA
        sitekey=ENV_PUBLIC_CAPTCHA_KEY
        onExpired={() => setVerificado(false)}
        onChange={() => (setVerificado(true))}
      />
      <br />
      <span className="worning">{valid.errors && valid.errors[0]}</span><br />
      {console.log(props.dados)}
      <Button
        type="button"
        onClick={() => props.history.push(
          props.dados.tipocrimepraticado !== 'Corrupção.' && props.dados.atodecorrupcao === '' && props.dados.tipocrimesofrido === ''
            ? '/questao52'
            : (props.dados.tipocrimesofrido !== 'Corrupção.' && props.dados.atodecorrupcao === '')
              ? '/questao51'
              : props.dados.atodecorrupcao === 'licitações ou contratos'
                ? '/questao61'
                : '/questao71',
        )}
      >QUESTÃO ANTERIOR

      </Button>
      <Button
        disabled={!isVerificado}
        onClick={handleSendEmail}
        type="button"
      >ENVIAR
      </Button>
    </form>
  );
}
const mapStateToProps = state => (
  {
    dados: state.QuestionarioReducers,
  }
);
export default connect(mapStateToProps, { insereDados })(Main);
